import { masterSvg, visaSvg, amexSvg, ccCardsSvg, accPaySvg, gpayWalletSvg, cardsSvg } from "../../assets/imageImport";
import { normalizePath } from "./common";

export const CardIcon = ({ cardType, alt = "Saved Card", className = "", style }) => {
  const getCardSvg = () => {
    const normalizedType = normalizePath(cardType ?? "");

    switch (normalizedType) {
      case "amex":
        return amexSvg;
      case "visa" || "visacard":
        return visaSvg;
      case "master" || "mastercard":
        return masterSvg;
      case "acc-pay":
        return accPaySvg;
      case "google-pay":
        return gpayWalletSvg;
      case "cards":
        return cardsSvg;
      default:
        return ccCardsSvg;
    }
  };

  return <img src={getCardSvg()} alt={alt} className={className} style={style} />;
};
